import React, { useState } from 'react';
import { Box } from 'localmed-core';
import Carousel, { Modal, ModalGateway } from 'react-images';
import Slider from 'react-slick';
import styled from '@emotion/styled';
import { css } from '@emotion/core';
import { space } from 'styled-system';

import './styles/slick.css';

const ImageWrapper = styled('button')(
  ({ theme }) => css`
    border: 0;
    padding: 0 ${theme.space.xxs};
    background-color: none;
  `
);

const Image = styled('img')`
  padding: 0;
  margin: auto;
  cursor: pointer;
`;

const SliderWrapper = styled(Box)(
  ({ theme }) => css`
    padding: 0 ${theme.space.md};
    overflow: hidden;

    .slick-prev:before,
    .slick-next:before {
      color: ${theme.colors.blue};
    }
  `,
  space
);

export default function Gallery({ images, ...props }) {
  const [currentImage, setCurrentImage] = useState(0);
  const [viewerIsOpen, setViewerIsOpen] = useState(false);

  const settings = {
    dots: false,
    infinite: false,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 3,
    responsive: [
      {
        breakpoint: 800,
        settings: {
          slidesToShow: 5,
          slidesToScroll: 3,
          infinite: true,
          dots: true,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
        },
      },
    ],
  };

  const openLightbox = (index) => {
    setCurrentImage(index);
    setViewerIsOpen(true);
  };

  const closeLightbox = () => {
    setCurrentImage(0);
    setViewerIsOpen(false);
  };

  return (
    <SliderWrapper {...props}>
      <Slider {...settings}>
        {images.map((image, index) => (
          <ImageWrapper type="button" onClick={() => openLightbox(index)} key={image.id}>
            <Image src={image.thumb} alt="Gallery slide" />
          </ImageWrapper>
        ))}
      </Slider>
      <ModalGateway>
        {viewerIsOpen ? (
          <Modal onClose={closeLightbox} allowFullscreen={false}>
            <Carousel
              currentIndex={currentImage}
              views={images.map((i) => ({
                ...i,
                source: i.photo,
              }))}
            />
          </Modal>
        ) : null}
      </ModalGateway>
    </SliderWrapper>
  );
}
